module.exports = __webpack_public_path__ + "media/images/screenshot_chat_new-ef48cd461037daddb5fe6dafc76dd6d4.png";